import Constant from '@/const'
import Store from '@/store/index.js'
export default {
  namespaced: true,
  state: {
    data: {},
  },
  mutations: {
    create(state, data) {
      state.data = data
    },
    update(state, data) {
      // 代理ログイン用
      if (data.ROLE) state.data.ROLE = data.ROLE
      if (data.ADMIN_USER_ID) state.data.ADMIN_USER_ID = data.ADMIN_USER_ID
      if (data.ADMIN_TANTO_ID) state.data.ADMIN_TANTO_ID = data.ADMIN_TANTO_ID
    },
    destroy(state, data) {
      state.data = null
      state.adminData = null
    },
    // 言語切り替え
    changeLanguage(state) {
      state.lang = state.lang === 'ja' ? 'en' : 'ja'
    },
  },
  actions: {
    get({ commit, dispatch }) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: Constant.API_URL.USER,
        error: { message: 'ユーザが存在しません。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          if (res.data.STATUS === Constant.USER.STATUS.RESTRICT) {
            throw new Error(
              `一定期間ご利用がなかったため利用停止となりました。<br>再度ご利用を再開される場合は弊社までご連絡ください。`
            )
          }
          commit('create', res.data)
        })
        .catch((err) => {
          throw new Error(err)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js